module.exports = __webpack_public_path__ + "img/dollar-currency.3bfcf8e7.svg";